module.exports = __webpack_public_path__ + "media/images/lb/666-5e72298cf2b1ac5dde91e4e7f97f02c5.svg";